import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_LIGHTER} from 'ui-library/Colors';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import FieldLabel from 'ui-library/inputs/FieldLabel';

const DefaultCanvasPlaceholder = (): JSX.Element => (
  <div className={css(styles.placeholderContainer)}>
    <div>
      <div>
        <FieldLabel label="Waiting for app...   " labelStyle={FieldLabel.STYLES.LABEL} />
      </div>
      <CenteredHorizontalThrobber />
    </div>
  </div>
);

export const InacessibleCanvasPlaceholder = (): JSX.Element => (
  <div className={css(styles.placeholderText)}>
    Unable to load canvas. Please try again or reach out to support@benchling.com if the issue persists
  </div>
);

export const RemovedFeaturePlaceholder = (): JSX.Element => (
  <div className={css(styles.placeholderText)}>
    This feature is no longer available. Contact your admin for help.
  </div>
);

export default DefaultCanvasPlaceholder;

const styles = StyleSheet.create({
  placeholderContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  placeholderText: {
    padding: '32px 0',
    backgroundColor: GRAY_LIGHTER,
    textAlign: 'center',
  },
});
